import React from 'react';
import { connect } from 'react-redux';

import classes from './BaggagePaxSelect.scss';
import Checkbox from '../../../UI/CommonCheckBox/CommonCheckBox';
import maleTravellerImage from './img/adult-male.svg';

import * as farePriceActions from '../../../../store/actions/index';

const baggagePaxSelect = (props) => {
    return (
        <ul>
            {   props.passengers.map(passenger => {
                    if(passenger.isSelected && passenger.travellerDetails.passengerClass !== 'INF') {
                        return <li className={classes.ListItem} key={passenger.paxID} onClick={
                            passenger.ssrDetails.ssrBaggageDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.baggageViewOIndex : props.baggageViewRIndex].desc === "" ? 
                            () => {
                                props.onSelectBaggage(passenger.paxID, props.flow, passenger.ssrDetails.ssrBaggageDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.baggageViewOIndex : props.baggageViewRIndex].desc === props.selectedBaggage[props.flow][props.flow === 'O' ? props.baggageViewO : props.baggageViewR].desc)
                                props.onAddAddon({addonLabel: "Baggage", amount: parseInt(props.amount, 10), legIndex: props.flow === 'O' ? props.baggageViewOIndex : props.baggageViewRIndex, leg: props.flow === 'O' ? 'O' : 'R'})
                             } : (
                                () => {
                                    props.onRemoveAddon("Baggage", parseInt(passenger.ssrDetails.ssrBaggageDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.baggageViewOIndex : props.baggageViewRIndex].amt, 10), props.flow === 'O' ? props.baggageViewOIndex : props.baggageViewRIndex, props.flow === 'O' ? 'O' : 'R');
                                    props.onDeselctBaggage(passenger.paxID, props.flow);
                                }
                            )}>
                        <div className={`u-flex align-items-center`}>
                            <img src={maleTravellerImage} alt='Baggage' className={`u-size46x46 mr-2`}/>
                            <div className={`u-flex justify-content-center f-column`}>
                                <p className={`u-fontSize13 u-textColorDark`}>{passenger.travellerDetails.firstName + ' ' + passenger.travellerDetails.lastName}</p>
                                <p>
                                    <span className={`u-fontSize13 u-textColorLight`}>{passenger.ssrDetails.ssrBaggageDetails.length !== 0 ? props.flow === 'O' ? passenger.ssrDetails.ssrBaggageDetails[0][props.baggageViewOIndex].desc : passenger.ssrDetails.ssrBaggageDetails[1][props.baggageViewRIndex].desc : null}</span>
                                    <span style={{display: (passenger.ssrDetails.ssrBaggageDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.baggageViewOIndex : props.baggageViewRIndex].desc !== "" && (passenger.ssrDetails.ssrBaggageDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.baggageViewOIndex : props.baggageViewRIndex].desc !== props.selectedBaggage[props.flow][props.flow === 'O' ? props.baggageViewO : props.baggageViewR].desc))  ? 'inline-block' : 'none'}}>
                                        {
                                            passenger.ssrDetails.ssrBaggageDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.baggageViewOIndex : props.baggageViewRIndex].desc !== props.selectedBaggage[props.flow][props.flow === 'O' ? props.baggageViewO : props.baggageViewR].desc ? 
                                            <React.Fragment>
                                                <span className="u-textColorDark">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                                <span onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    props.onRemoveAddon("Baggage", parseInt(passenger.ssrDetails.ssrBaggageDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.baggageViewOIndex : props.baggageViewRIndex].amt, 10), props.flow === 'O' ? props.baggageViewOIndex : props.baggageViewRIndex, props.flow === 'O' ? 'O' : 'R');
                                                    props.onSelectBaggage(passenger.paxID, props.flow);
                                                    props.onAddAddon({addonLabel: "Baggage", amount: parseInt(props.amount, 10), legIndex: props.flow === 'O' ? props.baggageViewOIndex : props.baggageViewRIndex, leg: props.flow === 'O' ? 'O' : 'R'})}} className={`u-cursorPointer u-textColorPrimary u-fontSize13`}>Update</span>
                                            </React.Fragment> : null
                                        }
                                    </span>
                                </p>
                            </div>
                        </div>
                        <Checkbox type="ssr" readOnly checked={(passenger.ssrDetails.ssrBaggageDetails[props.flow === 'O' ? 0 : 1][props.flow === 'O' ? props.baggageViewOIndex : props.baggageViewRIndex].desc !== "") ? true : false} />                
                    </li>
                    } else {
                        return null;
                    }
                })}
        </ul>   
    );
}

const mapStateToProps = state => {
    return {
        passengers: state.farePrice.passengers,
        baggageViewO: state.farePrice.baggageViewOneWay,
        baggageViewR: state.farePrice.baggageViewReturn,
        baggageViewOIndex: state.farePrice.baggageViewOneWayVal,
        baggageViewRIndex: state.farePrice.baggageViewReturnVal,
        selectedBaggage: state.farePrice.selectedBaggage
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSelectBaggage: (id, flow, isUpdate) => dispatch(farePriceActions.selectBaggageSSR(id, flow, isUpdate)),
        onDeselctBaggage: (id, flow) => dispatch(farePriceActions.deselectBaggage(id, flow)),
        onAddAddon: (addon) => dispatch(farePriceActions.addAddon(addon)),
        onRemoveAddon: (label, amount, legIndex, leg) => dispatch(farePriceActions.removeAddon(label, amount, legIndex, leg))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(baggagePaxSelect);


// WEBPACK FOOTER //
// ./src/components/Addons/Baggage/BaggagePaxSelect/BaggagePaxSelect.js